export function ticketError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}


export function setIsOk(state,payload){
    state.isOk = payload
}

export function flushTickets(state){
    state.tickets = []
    state.error= false
    state.errorMessage = ''
}

export function setTickets(state, payload){
    state.tickets = payload.data.tickets
    state.error= false
    state.errorMessage = ''
}

export function setImages(state, payload){
    state.images = payload.data.images
    state.error= false
    state.errorMessage = ''
}

export function setTicket(state, payload){
    state.ticket = payload
}

export function setActivity(state, payload){
    state.error = false
    state.errorMessage = ''
    state.activity = payload.data.activity
}

export function setTotal(state, payload){
    state.error = false
    state.errorMessage = ''
    state.total = payload.data.total[0].total
}

export function setTotalAbierto(state, payload){
    state.error = false
    state.errorMessage = ''
    state.abiertos = payload.data.totalabierto[0].abiertos
}

export function setTotalCerrado(state, payload){
    state.error = false
    state.errorMessage = ''
    state.cerrados = payload.data.totalcerrado[0].cerrados
}